<template>
    <div class="site-header">
        <div class="container">
            <!-- <a class="logo" href="./" >
                <img src="../assets/img/logo.png">
            </a> -->
            <div class="nav pull-right">
                <a href="./">
                    {{ $t('home') }}
                </a>
                <a href="./news.html">
                    {{ $t('news') }}
                </a>
                <a href="/news.html?tab=5">
                    {{ $t('wiki') }}
                </a>
                <a v-if="!arraign" :href="g.topup" target="_blank">
                    {{ $t('topup') }}
                </a>
                <a v-if="!arraign" :href="g.account" target="_blank">
                    {{ $t('account') }}
                </a>
                <a @click="showContact">
                    {{ $t('contact') }}
                </a>
                <a
                    class="noHighlight facebook"
                    :class="{hide: !g.facebook}"
                    :href="g.facebook"
                    target="_blank"
                    title="Facebook"
                >
                    <img src="../assets/img/facebook.png">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
/*
 * @description 页头组件，通用
 * @author momo
 * @update 2018/12/12
 */
export default {
    name: "SiteHeader",
    methods: {
        showContact () {
            this.$message('Email: support@eyougame.com', {
                showClose: true,
                btns: [
                    {
                        type: 'info',
                        text: this.$t('cancel')
                    },
                    {
                        type: 'primary',
                        text: this.$t('contact'),
                        tag: 'a',
                        href: 'mailto:support@eyougame.com'
                    }
                ]
            })
        }
    }
};
</script>

<style lang="scss">
/* 顶部导航条样式 */

.site-header {
    min-width: 1366px;
    height: 80px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.8);
    .logo {
        width: 191px;
        float: left;
        font-size: 0;
        z-index: 100;
        img {
            width: 100%;
            height: auto;
        }
    }
    .nav {
        a {
            display: inline-block;
            width: 110px;
            line-height: 80px;
            color: #c9c9dd;
            font-size: 18px;
            text-decoration: none;
            background: center bottom repeat-x;
            transition: all 0.25s ease;
            cursor: pointer;
        }

        span {
            display: block;
            padding-top: 5px;
            font-size: 12px;
            line-height: 16px;
            color: #858792;
        }

        .active,
        a:hover {
            color: #e4b653;
            background-image: url(../assets/img/nav.png);
        }

        .active span,
        a:hover span {
            color: #91763f;
        }

        .noHighlight:hover {
            color: #c9c9dd;
            background: none;
            opacity: 0.8;
        }

        .facebook {
            width: auto;
            padding-left: 20px;
            img {
                width: 46px;
                height: auto;
                vertical-align: middle;
            }
        }
    }
}
</style>